import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import routes from '@/router/routes';
import i18n from '@/i18n';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
    routes,
    mode: 'history'
});

const languageList = ['en', 'ru'];

router.beforeEach((to, from, next) => {
    const realLang = languageList.includes(to.params.lang);
    if (!realLang) {
        next({
            name: to.name,
            params: {
                lang: i18n.locale,
                id: to.params.id
            },
            query: {
                ...to.query
            }
        });
    } else {
        next();
    }
});

export default router;
